import { FormationDetailProps } from "@/types/formation";

export const balisageChantierFormation: FormationDetailProps = {
  id: "18",
  title: "Formation Balisage Chantier",
  description: "Cette formation a pour finalité de permettre au personnel désigné de connaître la réglementation applicable liée à la signalisation et à la circulation temporaire sur voiries adaptée aux travaux routiers et au balisage temporaire de chantier selon les exigences requises par l'arrêté du 6/11/1992, l'IT2 du 30/01/1989/décret à la signalisation des routes et autoroutes.",
  duration: "7 heures (1 jour)",
  category: "Sécurité Routière",
  imageSrc: "/images/formations/balisagefiche.webp",
  slug: "balisage-chantier",
  reference: "F-STC",
  price: "Sur devis – nous contacter",
  targetAudience: "Toute personne travaillant sur la voie publique, réalisant un balisage temporaire de chantier",
  prerequisites: [
    "Être âgé de 18 ans",
    "Être apte médical"
  ],
  objectives: [
    "Connaître la règlementation applicable liée à la signalisation et à la circulation temporaire",
    "Connaître les principes généraux de la signalisation temporaire",
    "Connaître les caractéristiques des signalisations temporaires",
    "Savoir adapter et sélectionner aux travaux routiers",
    "Connaître et mettre en place une signalisation temporaire conforme à l'arrêté du 6 Novembre 1992",
    "Organiser efficacement toute une signalisation de futures"
  ],
  program: [
    {
      title: "Partie théorique 40%",
      items: [
        "Les règles liés aux interventions sur la voie publique",
        "Les catégories de routes, les réseaux et les usagers",
        "Caractéristiques visuels et élémentaires",
        "Zones sécuritaires et règlementation - arrêté du 5/11/1992",
        "Objet de la signalisation",
        "Déviations",
        "Signaux",
        "Restrictions diverses sur les chaussées",
        "Particularités sur les chaussées bidirectionnelles",
        "Réglementation de la signalisation routière",
        "Principes fondamentaux de toutes signalisations",
        "Visibilité",
        "Principes",
        "Moyens",
        "Règles d'implantation",
        "La signalisation de circulation pour les chantiers",
        "La neutralisation des véhicules",
        "La signalisation des virages",
        "Installation des agents",
        "La neutralisation des voies",
        "Les règles liés aux interventions sur la voie publique",
        "Vitesses de référence",
        "Dispositifs de retenues sur chaussée",
        "Circulation alternée",
        "Déviation de circulation",
        "Chantiers fixes",
        "Chantiers mobiles",
        "Signalisation du nuit",
        "Travaux sur les bornes",
        "Danger sur autoroute sur la signalisation temporaire"
      ]
    },
    {
      title: "Partie pratique 60%",
      items: [
        "Mise en place d'une déviation temporaire sur chantier fixe et / ou réels",
        "Mise en place de matériel avec véhicules propres et sélective d'emprises formes",
        "Observation sur site avec les ajustements des moyens pratiques, véhicules",
        "Mise en situation pratique sur approches"
      ]
    }
  ],
  pedagogicalMethods: [
    "Exposés interactifs, démonstrations par le formateur, mise en situation pratique, exercice pratique de balisage sur site"
  ],
  evaluationMethods: [
    "En 1er jour de la formation : Questionnaire des besoins et positionnement de l'apprenant",
    "Pendant la formation : Atelier pratique en situation réelle + exercices applicatifs",
    "Fin de formation : QCM pour évaluation des acquis + évaluation de satisfaction à chaud",
    "Après la formation : Évaluation à froid pour vérifier les compétences de l'apprenant"
  ],
  certification: "Cette action de formation sera validée par un certificat de réalisation nominative, après la réalisation du QCM final par évaluation des acquis.",
  registrationProcess: [
    "Inscription par téléphone, par mail ou par le site internet",
    "Délai d'accès selon un agenda interne de session de l'entreprise",
    "Inscription 15 jours avant le début de la formation"
  ],
  accessibilityCriteria: "Pour toute personne en situation d'handicap, Nous sommes susceptibles d'accueillir les personnes moins de nous contacter au préalable pour étudier toute situation.",
  formatterInfo: {
    name: "Sebastien Davrainville - SDPSI Formation",
    phone: "06.22.61.04.09",
    email: "sdpsiformation@orange.fr",
    website: "www.sdpsi-formations.fr"
  }
};
